import { Text } from '@medly-components/core';
import royalBlue from 'theme/colors/royalBlue';
import Styled from '../Styled';
import { FormHeader, FormWrapper } from './OnboardingFormWrapper.styled';
import { OnboardingFormWrapperProps } from './types';

export const OnboardingFormWrapper = ({
    children,
    header = '',
    blueHeader = '',
    mediumHeader = '',
    hasDescription = true,
    headerWidth = '55rem'
}: OnboardingFormWrapperProps) => {
    const rowGap = !hasDescription ? '0' : '2.4rem';
    return (
        <FormWrapper direction="column">
            {header && typeof header === 'string' ? (
                <FormHeader width={headerWidth} textVariant="h1">
                    {header}
                </FormHeader>
            ) : (
                header
            )}
            <Styled.FlexBox style={{ zIndex: 1, transition: 'none', width: '100%' }} rowGap={rowGap} direction="column">
                <Styled.FlexBox direction="column" rowGap="0.2rem">
                    {blueHeader && (
                        <Text textColor={royalBlue[500]} textVariant="body1" textWeight="Light">
                            {blueHeader}
                        </Text>
                    )}
                    {mediumHeader && (
                        <Text textVariant="h2" textWeight="Light">
                            {mediumHeader}
                        </Text>
                    )}
                </Styled.FlexBox>
                {children}
            </Styled.FlexBox>
        </FormWrapper>
    );
};
